import { ApolloLink, Observable, fromPromise } from "apollo-link";
import pipe from "@insightfulscience/shared-utils/fn/pipe";
import { flatMap, onErrorResumeNext } from "../observable-utils";

const couldBeRecovered = (isRecoverable, errors) =>
	Array.isArray(errors) ? errors.some(isRecoverable) : isRecoverable(errors);

/**
 * @typedef {import("apollo-link").FetchResult} FetchResult
 * @typedef {import("apollo-link").Operation} Operation
 *
 * @param {(result: FetchResult) => boolean} isRecoverable
 * @param {(operation: Operation) => Promise<void>} recover
 */
const apolloRecoveryLink = (isRecoverable, recover) =>
	new ApolloLink((operation, forward) =>
		forward(operation).flatMap(result =>
			result.errors && couldBeRecovered(isRecoverable, result.errors)
				? pipe(
						recover(operation),
						fromPromise,
						flatMap(() => forward(operation)),
						onErrorResumeNext(result),
				  )
				: Observable.of(result),
		),
	);

export default apolloRecoveryLink;
